export default "__VITE_ASSET__BxksRaYy__"